import { StateCreator } from "zustand";

// --- Marketing Site Mode Type ---
export type MarketingSiteMode = "invite_only" | "closed";

// --- State Type ---
export type MarketingSliceState = {
  marketingSiteMode: MarketingSiteMode;
};

// --- Actions Type ---
export type MarketingSliceActions = {
  setMarketingSiteMode: (mode: MarketingSiteMode) => void;
};

// --- Combined Type ---
export type MarketingSlice = MarketingSliceState & MarketingSliceActions;

// --- Initial State ---
export const initialMarketingState: MarketingSliceState = {
  marketingSiteMode: "invite_only",
};

// --- Slice Creator ---
export const createMarketingSlice: StateCreator<
  MarketingSlice,
  [],
  [],
  MarketingSlice
> = (set) => ({
  ...initialMarketingState,

  setMarketingSiteMode: (mode) =>
    set({
      marketingSiteMode: mode,
    }),
});

// --- Selectors ---
export const marketing = {
  state: (s: MarketingSlice) => ({
    mode: s.marketingSiteMode,
    setMarketingSiteMode: s.setMarketingSiteMode,
  }),
  /**
   * Computed selectors based on marketing mode
   */
  computed: (s: MarketingSlice) => ({
    /** Show login CTA in all modes */
    showLoginCta: true,
    /** Show newsletter CTA in closed mode only */
    showNewsletterCta: s.marketingSiteMode === "closed",
    /** Mode check helpers */
    isInviteOnly: s.marketingSiteMode === "invite_only",
    isClosed: s.marketingSiteMode === "closed",
  }),
};
